import { init as sentryInit } from '@do/seashell';
import { ApolloProvider } from '@do/seashell/graphql';
import { WalrusGlobalStyle } from '@do/walrus';

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import client from './client';
import Style from './components/Style';

sentryInit('https://6edc8fb6c85e4294b525726a0698517f@sentry.io/1794139', {
  tracesSampleRate: 0.005
});

ReactDOM.render(
  <>
    <ApolloProvider client={client}>
      <App />
    </ApolloProvider>
    <WalrusGlobalStyle />
    <Style />
  </>,
  document.getElementById('root')
);
